import { get, post, remove } from './api';
import routes from './end-points';

export const adminUserWarrantiesApi = {
  initWarranties: (userId) => get(routes.adminUserWarranties.initWarranties(userId)),
  saveWarranty: (dto) => post(routes.adminUserWarranties.saveWarranty, dto),
  deleteWarranty: (warrantyId) => remove(routes.adminUserWarranties.deleteWarranty(warrantyId)),
};
